import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { useLang } from "@/lib/LanguageContext";
import { ARTICLES } from "@/lib/articles";
import { card, articleImage } from "@/lib/images";
import PageShell from "@/components/PageShell";
import Seo from "@/components/Seo";
import ImageHero from "@/components/ImageHero";
import ImageCard from "@/components/ImageCard";

export default function JournalHub() {
  const { t, lang } = useLang();
  const j = t.journal;
  const [featured, ...rest] = ARTICLES;
  const f = featured[lang];
  const readLabel = lang === "fr" ? "Lire le briefing" : "Read the briefing";

  return (
    <PageShell>
      <Seo title={j.seoTitle} description={j.seoDesc} />

      <ImageHero testId="journal-hero" image="glassDome" eyebrow={j.eyebrow} titleA={j.title} text={j.intro} />

      <section data-testid="journal-featured" className="py-14 sm:py-28 px-6 lg:px-10">
        <Link
          to={`/journal/${featured.slug}`}
          data-testid={`journal-article-${featured.slug}`}
          className="group max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 items-center"
        >
          <div className="lg:col-span-7 overflow-hidden aspect-[16/10] bg-stone-200">
            <img src={card(articleImage(featured.slug))} alt={f.title} className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
          </div>
          <div className="lg:col-span-5">
            <p className="eyebrow !text-stone-400">
              {f.category} · {f.readTime}
            </p>
            <h2 className="mt-5 font-serif text-3xl sm:text-4xl text-stone-900 leading-tight">{f.title}</h2>
            <p className="mt-5 text-stone-600 leading-relaxed">{f.abstract}</p>
            <span className="mt-6 inline-flex items-center gap-2 text-sm text-stone-800 border-b border-stone-300 group-hover:border-stone-900 pb-1 transition-colors">
              {readLabel} <ArrowRight size={13} />
            </span>
          </div>
        </Link>
      </section>

      <section data-testid="journal-grid" className="pb-28 sm:pb-32 px-6 lg:px-10">
        <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14">
          {rest.map((article) => {
            const a = article[lang];
            return (
              <ImageCard
                key={article.slug}
                to={`/journal/${article.slug}`}
                testId={`journal-article-${article.slug}`}
                image={articleImage(article.slug)}
                eyebrow={`${a.category} · ${a.readTime}`}
                title={a.title}
                text={a.abstract}
                cta={readLabel}
                aspect="aspect-[4/3]"
                as="h2"
              />
            );
          })}
        </div>
      </section>
    </PageShell>
  );
}
